module.exports = __webpack_public_path__ + "static/media/1POLICY48.270ce4f1.jpg";